/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

"use strict";

var Model = require("../types/Model.js");
const AsyncStorage = require("@react-native-async-storage/async-storage").default;

var trialInfoKey = "has_done_trial";

module.exports = new Model({
	name: "trialwizard",
	init: init,
	listeners: listeners,
	triggers: triggers,

	_account: "",
	_personal: null,

	hide: hide_wizard,
});

function init() {
	this.push({
		active: false,
		step: "intro",
		token: "",
	});
}

function listeners() {
	return {
		"nologin:updated": handle_nologin_update,
		"nologin:trial:created": handle_created,
		"personal:updated": handle_personal_update,
		"availability:updated": handle_availability_update,
	};
}

function triggers() {
	return {
		"show": show_wizard,
		"hide": hide_wizard,
		"cancel": cancel_wizard,
		"try": create_account
	};
}

function show_wizard() {
	this.extend({
		active: true,
		step: "intro",
		token: ""
	});
}

function hide_wizard() {
	this._account = "";
	this.extend({
		active: false
	});
}

function cancel_wizard() {
	var account = this._account;
	this.hide();
	if (!account) return;
	this.emit("nologin:trigger:destroy", {
		account: account
	});
}

function handle_nologin_update(data) {
	if (!this.data.active) return;
	var token = data.token;
	if (!token) return;
	this.extend({
		step: "token",
		token: token
	});
}

function create_account() {
	this.emit("nologin:trigger:trial:create", {
		fname: this._personal.fname + " trial",
		lname: this._personal.lname
	});
}

function handle_created(data) {
	if (!this.data.active) return;
	var account = data._id;
	this._account = account;
	this.emit("availability:trigger:add", {
		who: [account]
	});
	this.emit("nologin:trigger:token", {
		account: account
	});
}

function handle_personal_update(personal) {
	this._personal = personal;
}

function handle_availability_update(availability) {
	if (!this.data.active) return;
	var account = this._account;
	if (!account) return;
	var isActive = availability[account];
	if (!isActive) return;
	AsyncStorage.setItem(trialInfoKey, new Date());
	hide_wizard.call(this);
	// Todo: Show tutorial for highlighting the contact
}
